import { IRateTrendForm } from "models/RateTrend";
import { axios } from "../middleware";

export const getLaneTrendAPI = async ({
  offset,
  origin_city,
  origin_state,
  destination_city,
  destination_state,
  trailerTypes
}: IRateTrendForm) => {
  return axios.get("/ratematrix/details/", {
    params: {
      offset,
      origin_city,
      origin_state,
      destination_city,
      destination_state,
      trailerTypes
    }
  });
};

export const getRateDetailsAPI = async ({
  origin_city,
  origin_state,
  destination_city,
  destination_state,
  trailerTypes
}: IRateTrendForm) => {
  return axios.get("/ratematrix/", {
    params: {
      origin_city,
      origin_state,
      destination_city,
      destination_state,
      trailerTypes
    }
  });
};
